<template>
  <QueueItem @handle-click="launchModal">
    <QueueItemDetail :item="item" class="grid__col--6 queue-item__detail--notes queue-item__detail--no-horiz-padding" :class="`queue-item__color--${statusClass}`">
      <div class="modal__content-title">
        <span class="modal__wo-id h-color-fuel-blue">FM{{ item.work_order_id }}</span>
        <span class="modal__item-title" v-html="formattedTitle"></span>
        <div class="modal__item-details" v-if="includeDetails" v-html="item.details"></div>
      </div>
      <div class="modal__wo-objective h-italic-text" v-if="item.objective">{{ item.objective }}</div>
      <div class="modal__info-pills">
        <div class="modal__info-pill modal__wo-status">
          <div class="modal__wo-status-dot"  :class="`modal__wo-status-dot--${statusClass}`"></div>
          {{ statusTitle }}
        </div>
        <div class="modal__info-pill modal__wo-department">
          <span class="glyphicon queue-detail__glyph" :class="[departmentIcon, `queue-detail__glyph--${item.department}`]" aria-hidden="true"></span></a>
          {{ departmentTitle }}
        </div>
        <div class="modal__info-pill modal__wo-specialty">{{ item.specialty }}</div>
        <div class="modal__info-pill modal__wo-created">
          <span class="glyphicon queue-detail__glyph glyphicon-calendar h-color-fuel-navy" aria-hidden="true" v-tooltip="{ content:`Start Date: ${startDate}` }"></span>
          {{ startDate }}
        </div>
        <div class="modal__info-pill modal__wo-time-spent">
          <span class="glyphicon queue-detail__glyph glyphicon-time h-color-fuel-navy" aria-hidden="true" v-tooltip="{ content: 'Time Spent' }"></span>
          {{ item.timeSpent }} min
        </div>
      </div>
    </QueueItemDetail>
    <QueueItemDetail :item="item" class="grid__col--3 queue-item__detail--notes queue-item__detail--no-horiz-padding">
      <People :item="item"></People>
      <FileAttachment v-for="(file, index) in agendaFiles" :key="index" :file="file"></FileAttachment>
      <CommentCount :item="item"></CommentCount>
    </QueueItemDetail>
    <QueueItemDetail :item="item" class="grid__col--3 queue-item__detail--notes">
      <div class="queue-detail queue-detail__text grid" v-if="item.note">
        <div class="grid__col--1 h-no-padding h-center-align">
          <i class="fas fa-sticky-note"></i>
        </div>
        <div class="grid__col--11 h-no-margin h-no-padding">
          <div class="item-header__note-text" v-html="item.note"></div>
        </div>
      </div>
    </QueueItemDetail>
  </QueueItem>
</template>

<script>
  import lodash from 'lodash';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import QueueItem from './QueueItem.vue';
  import QueueItemDetail from './QueueItemDetail.vue';
  import FileAttachment from './FileAttachment.vue';
  import People from './People.vue';
  import CommentCount from './CommentCount.vue';

  export default {
    name: 'WorkOrder',
    components: {
      QueueItem,
      QueueItemDetail,
      People,
      CommentCount,
      FileAttachment,
    },
    props: ['item', 'index'],
    data() {
      return {
        asIsStatuses: ['hold', 'member review', 'killed', 'scheduled'],
        completeStatuses: ['complete'],
      };
    },
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda', 'titleTransforms', 'glyphs']),
      includeDetails() {
        return this.item.hasOwnProperty('includeDetails') && this.item.includeDetails;
      },
      startDate() {
        return this.displayDate(this.item.startDate !== '0000-00-00' ? this.item.startDate : this.item.submittedDate, 'MM/DD/YYYY')
      },
      contacts() {
        if (this.item.hasOwnProperty('contactIDs')) {
          return lodash.filter(this.currentAgenda.contacts, contact => this.item.contactIDs.includes(contact.id));
        }
        return [];
      },
      users() {
        if (this.item.hasOwnProperty('fuelUserIDs')) {
          return lodash.filter(this.currentAgenda.users, user => this.item.fuelUserIDs.includes(user.id));
        }
        return [];
      },
      agendaFiles() {
        return this.item.hasOwnProperty('agendaFiles') ? this.item.agendaFiles : [];
      },
      departmentTitle() {
        const transform = lodash.find(this.titleTransforms, titleTransform => titleTransform.value === this.item.department);
        return transform !== undefined ? transform.transform : lodash.startCase(this.item.department);
      },
      departmentIcon() {
        if (this.item.department !== null && this.item.department !== undefined) {
          const icon = lodash.find(this.glyphs, { status: this.item.department });
          if (icon !== undefined) {
            return `glyphicon-${icon.icon}`;
          }
        }
        return '';
      },
      statusTitle() {
        let status = '';
        if (this.asIsStatuses.includes(this.item.status)) {
          status = this.item.status;
        } else if (this.completeStatuses.includes(this.item.status)) {
          status = 'complete';
        } else {
          status = 'in progress';
        }
        const transform = lodash.find(this.titleTransforms, titleTransform => titleTransform.value === lodash.startCase(status));
        return transform !== undefined ? transform.transform : lodash.startCase(status);
      },
      statusClass() {
        return lodash.kebabCase(this.statusTitle);
      },
      formattedTitle() {
        return this.item.title;
        // return this.item.title.replace(/ - /g, '<br />');
      },
    },
    methods: {
      displayDate(aDate, format) {
        if (aDate !== null && aDate !== '') {
          return moment(aDate).format(format);
        }
        return aDate;
      },
      launchModal() {
        this.$store.dispatch('meetingAgendas/activateModal', this.index);
      },
    },
  };
</script>

